import {
  AREAS,
  GET_AREAS,
  GET_QUESTIONS,
  QUESTIONS
} from '../actions';

const INIT_STATE = {
  questions: [],
  areas: [],
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUESTIONS:
    case GET_AREAS:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case QUESTIONS:
      return {
        ...state,
        questions: action.payload.questions,
        loading: false,
      };
    case AREAS:
      return {
        ...state,
        areas: action.payload.areas,
        loading: false,
      };
    default:
      return { ...state };
  }
};
